import { readFileSync } from "fs";
import path from "path";
import { resolvePath } from "@vxrn/resolve";
var absorbedPackages = {
  "react-native-safe-area-context": "safe-area-context"
};
function undeclaredAbsorbedPackages(root) {
  var app = JSON.parse(readFileSync(path.join(root, "package.json"), "utf8"));
  var declared = {
    ...app.dependencies,
    ...app.devDependencies
  };
  return Object.entries(absorbedPackages).filter(function(param) {
    var [name] = param;
    return !(name in declared);
  });
}
function absorbedPackageNames(root) {
  return undeclaredAbsorbedPackages(root).map(function(param) {
    var [name] = param;
    return name;
  });
}
function absorbedPackageAliases(root, platform) {
  var absorbed = undeclaredAbsorbedPackages(root);
  if (!absorbed.length) return {};
  var oneRoot = path.dirname(resolvePath("one/package.json", root));
  var entry = platform === "web" ? "index.mjs" : "index.native.js";
  return Object.fromEntries(absorbed.map(function(param) {
    var [name, dir] = param;
    return [
      name,
      path.join(oneRoot, "dist", "esm", dir, entry)
    ];
  }));
}
export {
  absorbedPackageAliases,
  absorbedPackageNames
};
//# sourceMappingURL=absorbedPackages.js.map
